import React from 'react';

type ContentWrapperProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  id?: string;
};

const ContentWrapper: React.FC<ContentWrapperProps> = ({
  children,
  style,
  id,
}) => {
  return (
    <div className="omtur-content-wrapper" style={style} id={id}>
      {children}
    </div>
  );
};

export default ContentWrapper;
